import "core-js/modules/es.function.name.js";
import { getValidationStateFromEditQuestion } from '@/services/SurveyManagementService';
export default {
  editQuestionValidation: function editQuestionValidation(state) {
    if (state.editPageState && state.editPageState.name === 'EDIT_QUESTION' && !state.fullSurvey.isLoading) {
      return getValidationStateFromEditQuestion(state.editPageState.data.editQuestion, state.editPageState.data.question.questionType, state.fullSurvey.data.enabledLanguages);
    }
    return {};
  }
};